import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function J() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('solar_panel_175w');
    const { locale } = useRouter();
    const IMGS = [
        'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717125827339/10_1.png',
        'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717125837823/10_2.png',
        'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717125848102/10_3.png',
        'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717125856355/10_4.png',
    ];

    return (
        <div className={`sp-175w-J sp-175w-common ${css['sp-175w-J']}`}>
            <div className="info center">
                <p className="title">{t('J_title')}</p>
            </div>
            <ul className="grid">
                {[1, 2, 3, 4]?.map((item: any, k: number) => (
                    <li className={`box box-${item}`} key={k}>
                        <div className="box-img">
                            <EFPicture src={IMGS[k]} alt={t(`J_text${k + 1}`)} />
                        </div>
                        <p className="text">{t(`J_text${k + 1}`)}</p>
                    </li>
                ))}
            </ul>
            <p className="tip">{t('J_tip')}</p>
        </div>
    );
}
